/**
 * Keep this in alphabetical order please!
 * TODO: runtime configuration of these tests
 */
const HA_PULSE_AA_TEST = 'HA_PULSE_AA_TEST';
const HA_PULSE_ACTIVITY_INDICATORS = 'ha_pulse_activity_indicators'; // 28106
const HA_PULSE_CREATE_BOARD = 'ha_pulse_create_board'; // 28908
const HA_PULSE_EMPTY_SEARCH_TEST = 'ha_pulse_empty_search_test'; // 28200
const HA_PULSE_IMPROVED_EMPTY_STATE = 'ha_pulse_improved_empty_state'; // 29036
const HA_PULSE_PUBLIC_SEARCH_TEST = 'ha_pulse_public_search_test'; // 28459
const HA_PULSE_GOOGLE_MAP = 'ha_pulse_google_map'; // 27654
const HA_PULSE_GUEST_CONTEXT_TEST = 'ha_pulse_guest_context_test'; // 29041
const HA_PULSE_HEART_REMOVE_TEST = 'ha_pulse_heart_remove_test'; // 28891
const HA_PULSE_INVITE_ACCEPT_MODAL_TEST = "ha_pulse_invite_accept_modal_test"; // 29313
const HA_PULSE_PRIVATE_SEARCH_TEST = 'ha_pulse_private_search_test'; // 28608
const HA_PULSE_RECENT_ACTIVITY_TEST = 'ha_pulse_recent_activity_test';
const HA_PULSE_RECO_AB_TEST = 'ha_pulse_reco_ab_test';
const HA_PULSE_REMOVE_BACK_BUTTON_TEST = 'ha_pulse_remove_back_button_test';
const HA_PULSE_SHARED_TRIPBOARD_AB_TEST = 'ha_pulse_shared_tripboard_ab_test';
const HA_PULSE_SIMILAR_PROPERTIES = 'ha_pulse_similar_properties'; // 27564
const HA_PULSE_SWAP_REVIEWS_PRICE = 'ha_pulse_swap_reviews_price'; // 27249
const HA_PULSE_TRIPBOARD_INVITE_BUTTON_THROTTLE = 'ha_pulse_tripboard_invite_button_throttle'; // 26484
const HA_PULSE_TRIPBOARD_SHARE_BUTTON_THROTTLE = 'ha_pulse_tripboard_share_button_throttle'; // 26440
const HA_PULSE_TRIPBOARD_SHARE_FACEBOOK_THROTTLE = 'ha_pulse_tripboard_share_facebook_throttle';
const HA_PULSE_TRIPBOARD_SHARE_PINTEREST_THROTTLE = 'ha_pulse_tripboard_share_pinterest_throttle';
const HA_PULSE_TRIPBOARD_SHARE_TWITTER_THROTTLE = 'ha_pulse_tripboard_share_twitter_throttle';
const HA_PULSE_TRIPBOARDS_CAROUSEL_TEST = 'ha_pulse_tripboards_carousel_test'; // 27507
const LOADING_ANIMATION = 'ha_pulse_tripboard_loading_animation_test';
const NEW_MODAL = 'ha_pulse_tripboard_new_modal_test'; // 25891
const SKELETON_ABC = 'ha_pulse_skeleton_abc_test'; // 25647
const WATERFALL_AB = 'ha_pulse_waterfall_ab_test'; // 25978
const HA_GDPR_BANNER = 'ha_gdpr_banner';

// Put all tests in this array!!! :)
const EVALUATE = [
    HA_PULSE_AA_TEST,
    HA_PULSE_ACTIVITY_INDICATORS,
    HA_PULSE_CREATE_BOARD,
    HA_PULSE_EMPTY_SEARCH_TEST,
    HA_PULSE_IMPROVED_EMPTY_STATE,
    HA_PULSE_PUBLIC_SEARCH_TEST,
    HA_PULSE_GOOGLE_MAP,
    HA_PULSE_GUEST_CONTEXT_TEST,
    HA_PULSE_HEART_REMOVE_TEST,
    HA_PULSE_INVITE_ACCEPT_MODAL_TEST,
    HA_PULSE_PRIVATE_SEARCH_TEST,
    HA_PULSE_RECENT_ACTIVITY_TEST ,
    HA_PULSE_RECO_AB_TEST,
    HA_PULSE_REMOVE_BACK_BUTTON_TEST,
    HA_PULSE_SHARED_TRIPBOARD_AB_TEST,
    HA_PULSE_SIMILAR_PROPERTIES,
    HA_PULSE_SWAP_REVIEWS_PRICE,
    HA_PULSE_TRIPBOARD_INVITE_BUTTON_THROTTLE,
    HA_PULSE_TRIPBOARD_SHARE_BUTTON_THROTTLE,
    HA_PULSE_TRIPBOARD_SHARE_FACEBOOK_THROTTLE,
    HA_PULSE_TRIPBOARD_SHARE_PINTEREST_THROTTLE,
    HA_PULSE_TRIPBOARD_SHARE_TWITTER_THROTTLE,
    HA_PULSE_TRIPBOARDS_CAROUSEL_TEST,
    LOADING_ANIMATION,
    NEW_MODAL,
    SKELETON_ABC,
    WATERFALL_AB,
    HA_GDPR_BANNER
];

// Will we use this? Not sure.
const EVALUATE_AND_LOG = [];

module.exports = {
    EVALUATE,
    EVALUATE_AND_LOG,
    HA_PULSE_AA_TEST,
    HA_PULSE_ACTIVITY_INDICATORS,
    HA_PULSE_CREATE_BOARD,
    HA_PULSE_EMPTY_SEARCH_TEST,
    HA_PULSE_IMPROVED_EMPTY_STATE,
    HA_PULSE_PUBLIC_SEARCH_TEST,
    HA_PULSE_PRIVATE_SEARCH_TEST,
    HA_PULSE_GOOGLE_MAP,
    HA_PULSE_GUEST_CONTEXT_TEST,
    HA_PULSE_HEART_REMOVE_TEST,
    HA_PULSE_INVITE_ACCEPT_MODAL_TEST,
    HA_PULSE_RECENT_ACTIVITY_TEST,
    HA_PULSE_RECO_AB_TEST,
    HA_PULSE_REMOVE_BACK_BUTTON_TEST,
    HA_PULSE_SHARED_TRIPBOARD_AB_TEST,
    HA_PULSE_SIMILAR_PROPERTIES,
    HA_PULSE_SWAP_REVIEWS_PRICE,
    HA_PULSE_TRIPBOARD_INVITE_BUTTON_THROTTLE,
    HA_PULSE_TRIPBOARD_SHARE_BUTTON_THROTTLE,
    HA_PULSE_TRIPBOARD_SHARE_FACEBOOK_THROTTLE,
    HA_PULSE_TRIPBOARD_SHARE_PINTEREST_THROTTLE,
    HA_PULSE_TRIPBOARD_SHARE_TWITTER_THROTTLE,
    HA_PULSE_TRIPBOARDS_CAROUSEL_TEST,
    LOADING_ANIMATION,
    NEW_MODAL,
    SKELETON_ABC,
    WATERFALL_AB,
    HA_GDPR_BANNER
};



// WEBPACK FOOTER //
// ./src/universal/abacus/experiments.js